/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_iupac_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convert an IUPAC nucleotide motif into a regular expression for sequence searching.`)
};

const es_iupac_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convierte un motivo de nucleótidos IUPAC en una expresión regular para la búsqueda de secuencias.`)
};

const de_iupac_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wandeln Sie ein IUPAC-Nukleotidmotiv in einen regulären Ausdruck zur Sequenzsuche um.`)
};

const nl_iupac_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zet een IUPAC-nucleotidemotief om naar een reguliere expressie voor het doorzoeken van sequenties.`)
};

const fr_iupac_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertissez un motif nucléotidique IUPAC en une expression régulière pour la recherche de séquences.`)
};

const it_iupac_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converte un motivo nucleotidico IUPAC in un'espressione regolare per la ricerca di sequenze.`)
};

const pt_br2_iupac_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converta um motivo de nucleotídeos IUPAC em uma expressão regular para busca de sequências.`)
};

const pt_iupac_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converta um motivo de nucleótidos IUPAC numa expressão regular para pesquisa de sequências.`)
};

const ja_iupac_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IUPACヌクレオチドモチーフを配列検索用の正規表現に変換します。`)
};

const zh_iupac_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将 IUPAC 核苷酸模体转换为用于序列搜索的正则表达式。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const iupac_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.iupac_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("iupac_tool_description", locale)
	if (locale === "en") return en_iupac_tool_description(inputs)
	if (locale === "es") return es_iupac_tool_description(inputs)
	if (locale === "de") return de_iupac_tool_description(inputs)
	if (locale === "nl") return nl_iupac_tool_description(inputs)
	if (locale === "fr") return fr_iupac_tool_description(inputs)
	if (locale === "it") return it_iupac_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_iupac_tool_description(inputs)
	if (locale === "pt") return pt_iupac_tool_description(inputs)
	if (locale === "ja") return ja_iupac_tool_description(inputs)
	return zh_iupac_tool_description(inputs)
};